import Vue from 'vue'
import Router from 'vue-router'
import appConfig from '../config/appConfig'
import search from "../views/search/search";

// import _ from 'lodash'
/**
 * 自定义路由跳转
 */
Router.prototype.pushPage = function (link, query) {
    this.push({
        path: link,
        query: query
    })
}
Vue.use(Router)
let redirecPage = appConfig.platform == 'H5' ? (localStorage.getItem("role")==='录入人员'?'customerList':'home'):'login'; // 进来及重置路由
// if (localStorage.getItem('download_app_status') == '1') {
//     redirecPage = 'user';
// }
export default new Router({
    hashbang: true,
    // mode: 'history',
    // base: '/sbspFront',
    // history: true, //这个参数改为false就可以了
    // base: '/test/cpis/',
    // history: true, // 这个参数改为false就可以了

    saveScrollPosition: true,
    suppressTransitionError: true,
    routes: [
        {
            path: '*',
            redirect: `/${redirecPage}`
        },
        {
            path: '/home', // 首页面
            name: 'home',
            component: resolve => require(['../views/index/home'], resolve)
        },
        {
            path: '/collection', // 首页面
            name: 'collection',
            component: resolve => require(['../views/collection/collection'], resolve)
        },
        {
            path: '/placeAnOrder',
            name: 'placeAnOrder',
            component: resolve => require(['../views/placeAnOrder/placeAnOrder'], resolve)
        },
        {
            path: '/viewInvoice', // 首页面
            name: 'viewInvoice',
            component: resolve => require(['../views/login/viewInvoice'], resolve)
        },
        {
            path: '/applyForInvoicing', // 首页面
            name: 'applyForInvoicing',
            component: resolve => require(['../views/apply/applyForInvoicing'], resolve)
        },
        {
            path: '/paymentStatus',
            name: 'paymentStatus',
            component: resolve => require(['../views/order/payment/paymentStatus'], resolve)
        },
        {
            path: '/register', // 信息注册
            name: 'register',
            component: resolve => require(['../views/login/register/register'], resolve)
        },
        {
            path: '/loginjudge', // 微信回调页面(用户身份认证)
            name: 'loginjudge',
            component: resolve => require(['../views/login/loginjudge/loginjudge'], resolve)
        },
        {
            path: '/login', // 登录页面
            name: 'login',
            component: resolve => require(['../views/login/login'], resolve)
        },
        {
            path: '/search', // 分类页
            name: 'search',
            component: resolve => require(['../views/search/search'], resolve)
        },

        {
            path: '/searchProduct', // 分类页
            name: 'searchProduct',
            component: resolve => require(['../views/search/searchProduct'], resolve)
        },

        {
            path: '/checkout', // 提交订单
            name: 'checkout',
            component: resolve => require(['../views/order/checkout/checkout'], resolve)
        },
        {
            path: '/cart',  // 购物车
            name: 'cart',
            component: resolve => require(['../views/cart/cart'], resolve)
        },
        {
            path: '/goods/',  // 商品信息
            name: 'goods',
            component: resolve => require(['../views/goods/goods'], resolve)
        },
        {
            path: '/payment/',  // 商品信息
            name: 'payment',
            component: resolve => require(['../views/order/payment/payment'], resolve)
        },
        {
            path: '/user', // 个人信息
            name: 'user',
            component: resolve => require(['../views/user/user'], resolve)
        },
        {
            path: '/sddl', // 数电登录
            name: 'sddl',
            component: resolve => require(['../views/user/sddl'], resolve)
        },
        {
            path: '/favorite',
            name: 'favorite',
            component: resolve => require(['../views/favorite/favorite'], resolve)
        },
        {
            path: '/updateMobile',  // 修改头像
            name: 'updateMobile',
            component: resolve => require(['../views/setting/updateMobile/updateMobile'], resolve)

        },
        {
            path: '/order', // 我的订单
            name: 'order',
            component: resolve => require(['../views/order/order'], resolve)
        },  
        {
            path: '/orderInfo', // 订单明细
            name: 'orderInfo',
            component: resolve => require(['../views/order/orderInfo'], resolve)
        },
        {
            path: '/kpdata',
            name: 'kpdata',
            component: resolve => require(['../views/kpdata/kpdata'], resolve)
        },
        {
            path: '/userData',
            name: 'userData',
            component: resolve => require(['../views/user/kpData/userData'], resolve)
        },
        {
            path: '/invoiceList', // 发票列表
            name: 'invoiceList',
            component: resolve => require(['../views/invoice/invoiceList'], resolve)
        }, {
            path: '/invoiceInfo', // 发票明细
            name: 'invoiceInfo',
            component: resolve => require(['../views/invoice/invoiceInfo'], resolve)
        },
        {
            path: '/text',
            name: 'text',
            component: resolve => require(['../views/text/text'])
        },
        {
            path: '/headerList', // 抬头列表
            name: 'headerList',
            component: resolve => require(['../views/user/kpData/headerList'], resolve)
        },

        {
            path: '/edit', // 抬头添加
            name: 'edit',
            component: resolve => require(['../views/user/kpData/edit/edit'], resolve)
        },
        {
            path: '/messageCenter', // 消息列表
            name: 'messageCenter',
            component: resolve => require(['../views/message/messageCenter'], resolve)
        },
        {
            path: '/messageContent', // 消息详情
            name: 'messageContent',
            meta:{keepAlive: true},
            component: resolve => require(['../views/message/messageContent'], resolve)
        },
        {
            path: '/aboutUs', // 抬头添加
            name: 'aboutUs',
            component: resolve => require(['../views/about/aboutUs'], resolve)
        },{
            path: '/contractList', // 合同列表
            name: 'contractList',
            component: resolve => require(['../views/user/htData/contractList'], resolve)
        },{
            path: '/advance',   //开票信息
            name: 'advance',
            component: resolve => require(['../views/advance/advancePaperTicket'],resolve)
        },
        {
            path: '/unitInformationCollection',   //录入信息收集表单
            name: 'unitInformationCollection',
            component: resolve => require(['../views/index/unitInformationCollection'],resolve)
        },
        {
            path: '/customerList',   //录入信息收集列表
            name: 'customerList',
            component: resolve => require(['../views/index/customerList'],resolve)
        },
        {
            path: '/unitCollection',   //单位收款
            name: 'unitCollection',
            component: resolve => require(['../views/index/unitCollection'],resolve)
        },
        {
            path: '/institutionsCollection',   //单位信息收集
            name: 'institutionsCollection',
            component: resolve => require(['../views/index/institutionsCollection'],resolve)
        }
    ]
});
